import { render, staticRenderFns } from "./waiterExam.vue?vue&type=template&id=1b25b3b1&scoped=true&"
import script from "./waiterExam.vue?vue&type=script&lang=js&"
export * from "./waiterExam.vue?vue&type=script&lang=js&"
import style0 from "./waiterExam.vue?vue&type=style&index=0&id=1b25b3b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b25b3b1",
  null
  
)

export default component.exports